// Facebook (Meta) Pixel — Leadmato.
//
// The base pixel is injected here at app boot (from src/index.js) rather than
// pasted into public/index.html, because that root HTML file is an Emergent
// platform-owned file we must not edit (see CLAUDE.md). For an SPA the effect
// is identical: fbq is defined once before render, then PageView is fired on
// every route from the router.
//
// Pixel ID 1039747691782780 is a public advertising identifier, not a secret.
// Override per-environment with REACT_APP_FB_PIXEL_ID (leave unset to use the
// production pixel).

const PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID || "1039747691782780";

// Keep local dev / test traffic out of the production pixel: only track on a
// real deployed host. If init is skipped, window.fbq is never defined and the
// track* helpers below no-op on their own.
function trackingEnabled() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host !== "localhost" && host !== "127.0.0.1" && host !== "";
}

let started = false;

// Inject the standard Meta Pixel base snippet and call fbq('init', …).
// Idempotent. Deliberately does NOT fire PageView — the router owns PageView
// (via trackPageView) so the initial load and every client-side navigation are
// counted from a single place, with no double-count on first paint.
export function initPixel() {
  if (started || !trackingEnabled()) return;
  if (typeof document === "undefined") return;
  started = true;

  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
}

// Fire a PageView. Called on initial load and on every client-side route change.
export function trackPageView() {
  if (typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", "PageView");
}

// Fire CompleteRegistration once a *verified* account actually exists — i.e.
// after /auth/verify-otp succeeds, NOT on /auth/signup (which returns ok:true
// even before the email is verified, and even if the OTP email fails to send).
export function trackCompleteRegistration() {
  if (typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", "CompleteRegistration", {
    content_name: "Leadmato Signup",
    status: "registered",
  });
}
